import React from 'react'

function ForwardIcon() {
  return (
    <div>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        width='12'
        height='12'
        viewBox='0 0 12 12'
        fill='none'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.79289 2.20711C3.40237 1.81658 3.40237 1.18342 3.79289 
          0.792893C4.18342 0.402369 4.81658 0.402369 5.20711 0.792893L9.70171 
          5.2875C9.7036 5.28936 9.70549 5.29123 9.70736 5.29311C9.90263 5.48837 
          10.0003 5.74431 10.0003 6.00023C10.0003 6.25616 9.90263 6.5121 9.70736 
          6.70736C9.70549 6.70924 9.7036 6.71111 9.70171 6.71297L5.20711 
          11.2076C4.81658 11.5981 4.18342 11.5981 3.79289 11.2076C3.40237 
          10.8171 3.40237 10.1839 3.79289 9.79336L7.58602 6.00023L3.79289 2.20711Z'
          fill='#04857E'
        />
      </svg>
    </div>
  )
}

export default ForwardIcon
